import api from '../api';
export default class DeviceService  {
    $devicesUpdated;
    $isAccessGranted;
    // get AccessGranted() {
    //     return this.$isAccessGranted;
    // }
    // set AccessGranted(value) {
    //     this.$isAccessGranted.next(value);
    // }
    
    //deviceBroadcast = new ReplaySubject<Promise<Devices>>();

    constructor() {
        if (navigator && navigator.mediaDevices) {
            ;
            navigator.mediaDevices.ondevicechange = () => {
                //this.deviceBroadcast.next(this.getDeviceOptions());
            }
        }

        //this.$devicesUpdated = this.deviceBroadcast.asObservable();
        //this.deviceBroadcast.next(this.getDeviceOptions());
    }



    async isGrantedMediaPermissions() {
        if (navigator && navigator.userAgent && navigator.userAgent.indexOf('Chrome') > 0) {
            return true; // Follows standard workflow for non-Chrome browsers.
        }
        ;
        if (navigator && navigator['permissions']) {
            try {
                const result = await navigator['permissions'].query({ name: 'camera' });
                
                if (result) {
                    if (result.state === 'granted') {
                        
                        return true;
                    } else {
                        ;
                        const isGranted = await new Promise<boolean>(resolve => {
                            result.onchange = () => {
                                
                                const granted = _.target['state'] === 'granted';
                                if (granted) {
                                    resolve(true);
                                }
                            }
                        });
                        return isGranted;
                    }
                }
            } catch (e) {
                ;
                // This is only currently supported in Chrome.
                // https://stackoverflow.com/a/53155894/2410379
                return true;
            }
        }

        return false;
    }
    mediaDevices = []
     async getDeviceOptions() {
        const isGranted = await this.isGrantedMediaPermissions();
        
        if (navigator && navigator.mediaDevices && isGranted) {
            this.AccessGranted = isGranted;
            let devices = await this.tryGetDevices();
            if (devices.every(d => !d.label)) {
                devices = await this.tryGetDevices();
            }
            console.log("device Filter",devices.filter(d => !!d.label))
            return devices.filter(d => !!d.label);

            
        }

         console.log("null",null)
        return null;
    }
    getMediaDevices() {
        return this.mediaDevices;
    }
    gotDevices(mediaDevices) {
        ;
        this.mediaDevices = mediaDevices;
      
        return mediaDevices;
    }

     async tryGetDevices() {
        const mediaDevices = await navigator.mediaDevices.enumerateDevices().then(res => {
            this.gotDevices(res);          
            return res;
        });
        const devices = ['audiooutput', 'videoinput'].reduce((options, kind) => {
            return options[kind] = mediaDevices.filter(device => device.kind === kind);
        }, [] );

        return devices;
    }
}